import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../../../Assets/UserDetails.css";
import "../../../Assets/Postsmanage.css";
import { ReactComponent as VerifiedIcon } from "../../../Assets/images/icon/verifiedIcon.svg";
import { ReactComponent as ArrowBackIcon } from "../../../Assets/images/icon/ArrowBack Icon.svg";
import { Avatar, Button, message } from "antd";
import { Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import RecipeMediaPost from "./RecipeMediaPost";
import { DeleteOutlined } from "@ant-design/icons";
import DeletePostModal from "./DeletePostModal";
import { fetchRecipe } from "../useAPIDetails/usePostRelatedAPI";

const RecipeDetailedPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [postDetails, setPostDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        if(!id) {
          throw new Error("Post ID is required to fetch post details.");
        }
        const result = await fetchRecipe(id);
        setPostDetails(result.data.post);
      } catch (error) {
        message.error(error?.response?.data?.message || "An error occurred while fetching post details.");
      } finally {
        setLoading(false);
      }
    };

    fetchPostDetails();
  }, [id]);

  const handleDelete = () => {
    setIsModalVisible(true);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!postDetails) {
    return <div>No post details available.</div>;
  }

  const {
    createdByUser,
    pictures,
    keywords,
    reactionsCount,
    title,
    description,
    cookingHours,
    cookingMinutes,
    numberOfServings,
    ingredients,
    level,
    diets,
    categories,
    steps,
  } = postDetails;

  const handleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1); 
    } else {
      navigate("/post-management");
    }
  };

  return (
    <>
      <div className="user-detailed-container">
        <div className="header-user-detail sticky-header">
          <div
            className="arrow-icon-left pointer"
            onClick={handleBackClick}
          >
            <ArrowBackIcon />
          </div>
          <div className="header-texthead">Recipe Post Details</div>
        </div>

        <Row>
          <Col span={11} style={{ padding: "35px 35px 0 35px" }}>
            <RecipeMediaPost
              media={pictures?.map((pic) => ({
                type: pic?.picture?.fileFormat,
                url: pic?.picture?.fileUrl,
              }))}
            />
            <div className="section-post">
              <div className="post-detail-heading">Keywords: </div>
              <div className="post-detail-text">
                {keywords?.map((keyword) => keyword?.name).join(" ") || "---"}
              </div>
            </div>
            <div className="section-post">
              <div className="post-detail-heading">Recreated from: </div>
              <div className="post-detail-text">---</div>
            </div>
          </Col>
          <Col span={13} style={{ padding: "35px 35px 0 35px" }}>
            <div className="flex-center-between">
              <div className="flex-center-between" style={{ gap: 5 }}>
                <Avatar
                  src={createdByUser.profilePicture?.fileUrl}
                  style={{
                    width: "45px",
                    height: "45px",
                  }}
                />
                <div className="flex-center">
                  <div className="post-detail-text">
                    {createdByUser.userName}
                  </div>
                  {createdByUser.verified && (
                    <div className="verified-icon-size27px">
                      <VerifiedIcon />
                    </div>
                  )}
                </div>
              </div>
              <Button
                danger
                style={{
                  marginRight: "20px",
                }}
                type="link"
                icon={<DeleteOutlined />}
                onClick={handleDelete}
              />
            </div>
            <div className="flex-center-between">
              <div className="section-post">
                <div className="post-detail-heading">Title</div>
                <div className="post-detail-text">{title}</div>
              </div>
              <div className="font-like-details">{reactionsCount} Likes</div>
            </div>
            <div className="section-post">
              <div className="post-detail-heading">Description</div>
              <div className="post-detail-text">{description || "---"}</div>
            </div>
            <div style={{ display: "flex", padding: "10px 0" }}>
              <div className="post-detail-heading">Duration: </div>
              <div className="post-detail-text">
                {cookingHours} hours {cookingMinutes} minutes
              </div>
            </div>
            <div style={{ display: "flex", padding: "10px 0" }}>
              <div className="post-detail-heading">Servings: </div>
              <div className="post-detail-text">{numberOfServings}</div>
            </div>
            <div className="section-post">
              <div className="post-detail-heading">Ingredients: </div>
              {ingredients && ingredients.length > 0 ? (
                ingredients?.map((ingredient) =>
                  ingredient.name && ingredient.quantity !== null ? (
                    <div
                      key={ingredient.id}
                      className="post-detail-text ingredients-list"
                      style={{ width: "50%" }}
                    >
                      <div>{ingredient.name}</div>
                      <div>
                        {ingredient.quantity} {ingredient.unit || ""}
                      </div>
                    </div>
                  ) : null
                )
              ) : (
                <div
                  className="post-detail-text ingredients-list"
                  style={{ width: "50%" }}
                >
                  <div>---</div>
                </div>
              )}
            </div>
            <div style={{ display: "flex", padding: "10px 0" }}>
              <div
                style={{
                  width: "45%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="post-detail-heading">Dietary</div>
                <div className="post-detail-text">
                  {diets && diets.length > 0
                    ? diets?.map((diet, index) => (
                        <span key={diet.id}>
                          {diet.name}
                          {index !== diets.length - 1 && ", "}
                        </span>
                      ))
                    : "---"}
                </div>
              </div>
              <div
                style={{
                  width: "45%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="post-detail-heading">Level</div>
                <div className="post-detail-text">{level || "---"}</div>
              </div>
            </div>
            <div className="section-post">
              <div className="post-detail-heading">Categories: </div>
              <div className="post-detail-text">
                {categories && categories.length > 0
                  ? categories?.map((category, index) => (
                      <span key={category.id}>
                        {category.name}
                        {index !== categories.length - 1 && " , "}
                      </span>
                    ))
                  : "---"}{" "}
                {/* Fallback default text */}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{ padding: "0 35px 35px 35px" }}>
            <div className="section-post">
              <div className="post-detail-heading">Instructions:</div>
              {steps?.length > 0 ? (
                steps?.map((step, index) => (
                  <div
                    key={step.id}
                    className="step-container"
                    style={{
                      display: "flex",
                      alignItems: "stretch",
                      marginBottom: "20px",
                      height: "100%",
                    }}                  
                  >
                    {/* Step Details */}
                    <div style={{ flex: "3", display: "flex", flexDirection: "column" }}>
                      <div className="post-detail-heading">
                        Step {index + 1}: {step.title}
                      </div>
                      <div className="post-detail-text" style={{ flex: "1", display: "flex", alignItems: "center" }}>
                        {step.instruction || "No instruction provided."}
                      </div>
                    </div>

                    {/* Step Image */}
                    <div style={{ flex: "2", textAlign: "center" }}>
                      <div
                        className="images-container"
                        style={{ marginTop: "10px" }}
                      >
                        {step.pictures?.length > 0 ? (
                          step?.pictures?.map((pictureObj, pictureIndex) =>
                            pictureObj?.picture?.fileUrl ? (
                              <img
                                key={pictureIndex}
                                className="instrctions-image"
                                src={pictureObj.picture.fileUrl}
                                alt={`Step ${index + 1}  ${
                                pictureIndex + 1
                                }`}
                                style={{ margin: "10px", maxWidth: "150px" }}
                              />
                            ) : (
                              <div key={pictureIndex}>Image not available</div>
                            )
                          )
                        ) : (
                          <div>No images available</div>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="post-detail-text">
                  No instructions available.
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <DeletePostModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        postId={id}
      />
    </>
  );
};

export default RecipeDetailedPage;
